import {RoomleSdkWrapper} from '@/configurator/business-logic/roomle-sdk-wrapper';

const RoomleSdkWrapperPlugin = {
  install(Vue: any) {
    Vue.prototype.$roomleSdkWrapper = new RoomleSdkWrapper();
  },
};

export default RoomleSdkWrapperPlugin;
